import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { CiCircleAlert } from "react-icons/ci";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const NewActionModal = ({
    setPopupMex,
    account_id,
    show,
    handleClose,
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { org_id } = useParams()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        organization_ids: [`test-${org_id}`],
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };


    const handleSave = async () => {
        if (!formData.name.trim()) {
            setErrorMessage({ message: t.actions.action_title_req, display: true });
            return;
        }
        
        if (!formData.description.trim()) {
            setErrorMessage({ message: t.actions.action_desc_req, display: true });
            return;
        }

        if (formData.description.length > 300) {
            setErrorMessage({ message: t.actions.desc_too_long, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/save_action`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    act_id : null,
                    name: formData.name,
                    description: formData.description,
                    organization_ids: formData.organization_ids,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if(data.status == "success"){
                    navigate(`/e8console/organizations/${org_id}/actions/${data.act_id}`)
            }

            closeModal();
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };


    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.actions.create_new_action}</p>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">

                    <div className="label_input">
                        <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Ex. Post sales automation"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>
                    <div className="label_input">
                        <label className="input_label">{t.description} <MandatorySign message={t.mandatory_field} /></label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder={t.actions.desc_placeholder}
                            className="register_form_first textarea_reg fade-in"
                            autoComplete="off"
                        />
                    </div>

                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.create}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewActionModal;